module.exports = __webpack_public_path__ + "img/135deg.d61280f7.svg";